<template>
  <v-spacer></v-spacer>
</template>

<script>
import * as Reports from '@/modules/reports/reports'
// import * as LocalStorage from '@/core/local-storage'
// import * as arrayMove from 'array-move'
// import * as Admin from '@/core/admin'
// import * as Utils from '@/core/utils'
// import { app } from '@/main'
import { UserDetail } from '@/core/userDetail'
import * as Security from '@/core/security'

export default {
  props: ['value'],
  data () {
    return {
      userDetailFilterColumns: null,
      dialog: false,
      loading: false,
      columns: [...Reports.registrationSimpeColumns]
    }
  },
  watch: {
    columns: {
      handler (val) {
        if (!this.loading) {
          // console.log('--> Saving User Detail from PICKER', this.userDetailFilterColumns, JSON.stringify(val))
          /*
          if (this.userDetailFilterColumns !== null) {
            this.userDetailFilterColumns.Data1 = JSON.stringify(val)
            this.userDetailFilterColumns.save()
          }
          */
          // LocalStorage.save(user.token.User + 'columns', JSON.stringify(val))
          // this.$emit('input', this.columns)
        }
      },
      deep: true
    }
  },
  async mounted () {
    this.loading = true
    await Security.autoLogin()// Make sure we are logged in, since user is needed to get filters (User Details)
    await this.loadColumns()
    this.$emit('input', this.columns)
    this.loading = false
  },
  methods: {
    async loadColumns () {
      // console.log('--> USER ID from PICKER', Security.user.id)
      // this.userDetailFilterColumns = await UserDetail.load(Security.user.id, 'ReportRegistrationColumnsFilter')
      // console.log('--> Loaded User Detail from PICKER', this.userDetailFilterColumns)
      // console.log('--> Columns loaded! ', filter)

      // Columns in Registration Simple is hardcoded
      this.userDetailFilterColumns = new UserDetail({ UserId: Security.user.id, Name: 'ReportRegistrationSimpleColumnsFilter' })
      this.userDetailFilterColumns.Data1 = [...Reports.registrationSimpeColumns]
    }
    /*
    moveUp (index) {
      this.columns = arrayMove(this.columns, index, index - 1)
    },
    moveDown (index) {
      this.columns = arrayMove(this.columns, index, index + 1)
    }
    */
  }
}
</script>
